export default "__VITE_ASSET__DtEQJCZv__"